<template>
  <div class="login-wrapper d-flex flex-wrap overflow-hidden">
    <div class="login-bg"></div>
    <div class="login-form-wrap">
      <div class="login-form">
        <router-link to="/" class="logo">
          <img
            src="../../assets/img/logo_sportxxi_color.webp"
            alt="Image"
            class="d-block mx-auto"
          />
        </router-link>

        <!-- Acceso rápido solicitado para las pruebas operativas. -->
        <div class="quick-access mb-15">
          <p class="fs-12 text-muted mb-1 text-center">Acceso rápido</p>
          <div class="d-flex gap-2 justify-content-center flex-wrap">
            <button
              v-for="u in quickUsers"
              :key="u.usuario"
              type="button"
              class="btn btn-sm quick-btn"
              @click="rellenar(u)"
            >
              {{ u.label }}
            </button>
          </div>
        </div>

        <form @submit.prevent="iniciarSesion">
          <div class="form-group mb-15">
            <label class="d-block fs-14 text-black mb-2">Usuario</label>
            <input
              v-model="usuario"
              type="text"
              class="w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-title"
              placeholder="Usuario"
              autocomplete="username"
            />
          </div>
          <div class="form-group mb-20 position-relative">
            <label class="d-block fs-14 text-black mb-2">Clave</label>
            <input
              v-model="clave"
              type="password"
              placeholder="Ingresar Clave"
              class="w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black"
              autocomplete="current-password"
            />
          </div>
          <button
            class="btn style-one w-100 d-block"
            type="submit"
            :disabled="cargando"
          >
            <span v-if="cargando" class="spinner-border spinner-border-sm me-1" role="status"></span>
            {{ cargando ? 'Ingresando...' : 'Ingresar' }}
          </button>
          <p v-if="error" class="text-danger mt-3 text-center fs-14">{{ error }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/services/authService';

export default {
  name: 'LoginPage',
  data() {
    return {
      usuario: '',
      clave: '',
      error: '',
      cargando: false,
      quickUsers: [
        { label: 'ADMIN',          usuario: 'ADMIN',       clave: '78879306',  tienda: 'Todas' },
        { label: 'ECAMPOSG (939)', usuario: 'ECAMPOSG',   clave: '71818426',  tienda: '939' },
        { label: 'Melisa (939)', usuario: 'K. MELISA',    clave: 'K. MELISA', tienda: '939' },
        { label: 'Laura (939)',  usuario: 'LAURA',        clave: 'LAURA',     tienda: '939' },
        { label: 'Lisset (939)', usuario: 'LISSET',       clave: 'LISSET',    tienda: '939' },
        { label: 'Yuli (939)',   usuario: 'YULI',         clave: '41993855',  tienda: '939' },
        { label: 'Raul (1179)',  usuario: 'RAUL',         clave: '16726045',  tienda: '1179' },
        { label: 'Norma (1179)', usuario: 'NORMA',        clave: '10373764',  tienda: '1179' },
        { label: 'Deysi (1179)', usuario: 'DEYSI',        clave: 'DEYSI',     tienda: '1179' },
        { label: 'Mavila (1179)',usuario: 'MAVILA',        clave: 'MAVILA',    tienda: '1179' },
      ],
    };
  },
  methods: {
    rellenar(u) {
      this.usuario = u.usuario;
      this.clave = u.clave;
    },
    async iniciarSesion() {
      this.error = '';
      this.cargando = true;
      const res = await login(this.usuario, this.clave);
      this.cargando = false;
      if (res.success) {
        this.$router.push('/');
      } else {
        this.error = res.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  .login-bg {
    background-image: url(../../assets/img/login-bg.webp);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    width: 50%;
  }
  .login-form-wrap {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    width: 50%;
    background-color: var(--whiteColor);
    padding: 0 50px;
    .logo {
      display: block;
      margin-bottom: 20px;
      border-bottom: 1px solid #eef3fa;
      padding-bottom: 25px;
    }
    .login-form {
      border: 1px solid var(--ashColor);
      padding: 25px;
    }
  }
}
.quick-access {
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  background: #f9fafb;
}
.quick-btn {
  background: #ede9fe;
  color: #6d28d9;
  border: none;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 4px;
  &:hover { background: #ddd6fe; }
}
@media only screen and (max-width: 991px) {
  .login-wrapper {
    padding: 50px 0;
    .login-bg { display: none; }
    .login-form-wrap {
      width: 100%;
      height: 100%;
      padding: 0 12px;
      .login-form { padding: 20px 10px; }
    }
  }
}
@media only screen and (min-width: 992px) {
  .login-wrapper {
    height: 100vh;
    .login-bg { height: 100vh; }
  }
}
@media only screen and (min-width: 1920px) {
  .login-wrapper {
    .login-bg { width: 61%; }
    .login-form-wrap {
      width: 39%;
      padding: 0 100px;
      .logo { margin-bottom: 30px; padding-bottom: 45px; }
      .login-form { padding: 25px 35px; }
    }
  }
}
</style>
